import * as React from 'react';
import { overrideCSS } from '../../utils/function';
const internalStyles = require('./Tabs.pcss');


/*--- Interfaces ---*/

interface IProps {
    activeTab? : number;
    tabs : string[];
    handleClick : Function;
    styles? : Object;

}

interface IState {
    active? : number;
}


/*--- Component ---*/

export class Tabs extends React.Component<IProps, IState>{

    /**
     *  This component is a list of tabs to switch views
     */

    constructor(props) {
        super(props);

        let { activeTab } = props;

        this.state = { active: activeTab ? activeTab : 0 };
        this.handleTabClick = this.handleTabClick.bind(this);
    }

    /**
     *  Handles when a tab is clicked.
     *
     *  @param {number} index - The index of the tab to change
     */

    handleTabClick(index: number) {
        let { handleClick } = this.props;

        this.setState({ active: index });
        handleClick(index);
    }


    render() {
        let { tabs } = this.props,
            { active } = this.state,
            styles = this.props.styles ? overrideCSS(internalStyles, this.props.styles) : internalStyles;

        return (
            <div className={styles.tabList}>
                {tabs.map((entry, i) => {

                    /*- Determines whether this is the active tab -*/
                    let activeClass = i == active ? styles.active : '';

                    return (
                        <div className={`${styles.tab} ${activeClass}`}
                            key={i}
                            onClick={() => this.handleTabClick(i) }>
                            {entry}
                        </div>
                    );

                }) }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/client/assets/Tabs/Tabs.tsx